import React from "react";

const FindAccountFail = () => {
  return <div></div>;
};

export default FindAccountFail;
